import { Outlet } from 'react-router-dom'

export default function ToPayPayouts() {
    return (
        <Outlet />
    )
}
